/**
 * ArTableBundleContext
 *
 * Provides the bundle map to descendant components (context menus, DnD handlers).
 * Only populated when at least one bundle exists in the current table.
 */

import { createContext } from 'react';
import type { BundleMapEntry } from '../bundleDisplay';

type ArTableBundleContextValue = {
  bundleMap: Map<string, BundleMapEntry>;
};

const ArTableBundleContext = createContext<ArTableBundleContextValue | null>(null);

export { ArTableBundleContext };
export type { ArTableBundleContextValue };
